import { Action } from 'store/store';
import { AggregationField } from '../../aggregation/fields/aggregationFieldPortfolio';
import { PortfolioSummaryAggregatedData } from '../data/PortfolioSummaryDataState';
import { PortfolioSummaryDrillDown } from 'widgets/portfolioSummary/store/instances/component/PortfolioSummaryComponentState';

export enum PortfolioSummaryDataActionType {
    PORTFOLIO_SUMMARY_DATA_SET_AGGREGATED_DATA = 'PORTFOLIO_SUMMARY_DATA_SET_AGGREGATED_DATA',
    PORTFOLIO_SUMMARY_DATA_CLEAR_AGGREGATED_DATA = 'PORTFOLIO_SUMMARY_DATA_CLEAR_AGGREGATED_DATA',
    PORTFOLIO_SUMMARY_SET_DRILLDOWN_DATA = 'PORTFOLIO_SUMMARY_SET_DRILLDOWN_DATA',
}

export interface PortfolioSummarySetAggregatedDataPayload {
    aggregationField: AggregationField;
    data: PortfolioSummaryAggregatedData;
}

export type PortfolioSummarySetAggregatedDataAction = Action<
    PortfolioSummaryDataActionType.PORTFOLIO_SUMMARY_DATA_SET_AGGREGATED_DATA,
    PortfolioSummarySetAggregatedDataPayload
>;

export const portfolioSummarySetAggregatedDataAction: (
    aggregationField: AggregationField,
    data: PortfolioSummaryAggregatedData
) => PortfolioSummarySetAggregatedDataAction = (aggregationField, data) => ({
    type: PortfolioSummaryDataActionType.PORTFOLIO_SUMMARY_DATA_SET_AGGREGATED_DATA,
    payload: {
        aggregationField,
        data,
    },
});

export interface PortfolioSummaryClearAggregatedDataPayload {
    aggregationField: AggregationField;
}

export type PortfolioSummaryClearAggregatedDataAction = Action<
    PortfolioSummaryDataActionType.PORTFOLIO_SUMMARY_DATA_CLEAR_AGGREGATED_DATA,
    PortfolioSummaryClearAggregatedDataPayload
>;

export const portfolioSummaryClearAggregatedDataAction: (
    aggregationField: AggregationField
) => PortfolioSummaryClearAggregatedDataAction = (aggregationField) => ({
    type: PortfolioSummaryDataActionType.PORTFOLIO_SUMMARY_DATA_CLEAR_AGGREGATED_DATA,
    payload: {
        aggregationField,
    },
});

export interface PortfolioSummarySetDrillDownDataActionPayload {
    aggregationField: string;
    drillDown: PortfolioSummaryDrillDown;
    aggregatedData: PortfolioSummaryAggregatedData;
}

export type PortfolioSummarySetDrillDownDataAction = Action<
    PortfolioSummaryDataActionType.PORTFOLIO_SUMMARY_SET_DRILLDOWN_DATA,
    PortfolioSummarySetDrillDownDataActionPayload
>;

export const portfolioSummarySetDrilldownDataAction: (
    aggregationField: string,
    drillDown: PortfolioSummaryDrillDown,
    aggregatedData: PortfolioSummaryAggregatedData
) => PortfolioSummarySetDrillDownDataAction = (
    aggregationField,
    drillDown,
    aggregatedData
) => ({
    type: PortfolioSummaryDataActionType.PORTFOLIO_SUMMARY_SET_DRILLDOWN_DATA,
    payload: {
        aggregationField,
        drillDown,
        aggregatedData,
    },
});

export type PortfolioSummaryDataAction =
    | PortfolioSummaryClearAggregatedDataAction
    | PortfolioSummarySetAggregatedDataAction
    | PortfolioSummarySetDrillDownDataAction;
